import React from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

import GA from '../../../services/ga_events';

import './preview_section.scss';

export default function PreviewSection() {
  return (
    <div className="preview-section">
      <div className="content-background" />
      <div className="main-container">
        <div className="content-container">
          <div className="preview-logo" />
          <div className="preview-content">
            <div className="preview-text">
              Your team decides
              <br />
              {"what's important and fun"}
              <br />
              and makes it TV news
            </div>
            <Link
              className="preview-slack-button"
              to="/dashboard"
              onClick={() => {
                ReactGA.event(GA.landingAddToSlack);
              }
              }
            />
            <Link
              className="preview-webex-button"
              to="/dashboard"
              onClick={() => {
                ReactGA.event(GA.landingAddToWebex);
              }
              }
            />
            <img className="preview-tv" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/landing/preview_section/preview_section.jsx